export const BCRYPT_SALT_ROUNDS = 10;
